// Number formatting with abbreviated units for very large numbers.
const UNITS = [
  { v: 1e33, s: "Dc" }, // decillion
  { v: 1e30, s: "No" }, // nonillion
  { v: 1e27, s: "Oc" }, // octillion
  { v: 1e24, s: "Sp" }, // septillion
  { v: 1e21, s: "Sx" }, // sextillion
  { v: 1e18, s: "Qi" }, // quintillion
  { v: 1e15, s: "Qa" }, // quadrillion
  { v: 1e12, s: "T" },
  { v: 1e9, s: "B" },
  { v: 1e6, s: "M" },
  { v: 1e3, s: "K" },
];

const stripTrailingZero = (n) => {
  const fixed = n.toFixed(1);
  return fixed.endsWith(".0") ? fixed.slice(0, -2) : fixed;
};

// Format big numbers. Below 100k show localized integer with thousands separator.
export const formatNumber = (num) => {
  if (num === null || num === undefined || Number.isNaN(num)) return "0";
  const n = Math.floor(num);
  if (n < 100000) return n.toLocaleString("es-ES");
  for (const u of UNITS) {
    if (n >= u.v) {
      const val = n / u.v;
      return `${stripTrailingZero(val)}${u.s}`;
    }
  }
  return n.toLocaleString("es-ES");
};

// For berries counter we want small numbers with full precision, big ones abbreviated.
export const formatBerries = (num) => formatNumber(num);

// For "per second" we allow one decimal below 100
export const formatRate = (num) => {
  if (num === 0) return "0";
  if (num < 100) return num % 1 === 0 ? num.toString() : num.toFixed(1);
  return formatNumber(num);
};
